import { ProductCategoryKeyEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { NonLifeInsuranceFormFields } from "web_myplann/Portfolio/Forms/NonLifeInsuranceForm/NonLifeInsuranceFormFields";
import {
	NON_LIFE_INSURANCE_PRODUCT_CATEGORIES,
	type NonLifeInsuranceType,
} from "web_myplann/Portfolio/Forms/NonLifeInsuranceForm/nonLifeInsuranceTypes";
import { useCreateNonLifeInsuranceForm } from "web_myplann/Portfolio/Forms/NonLifeInsuranceForm/useCreateNonLifeInsuranceForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

type CreateNonLifeInsuranceFormProps = {
	insuranceType: NonLifeInsuranceType;
};

export const CreateNonLifeInsuranceForm = ({
	insuranceType,
}: CreateNonLifeInsuranceFormProps) => {
	const { t } = useResource();
	const { form, onSubmit, isPending } =
		useCreateNonLifeInsuranceForm(insuranceType);

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.AddShared.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
		>
			<NonLifeInsuranceFormFields
				control={form.control}
				insuranceType={insuranceType}
				productCategory={
					ProductCategoryKeyEnum[
						NON_LIFE_INSURANCE_PRODUCT_CATEGORIES[insuranceType]
					]
				}
			/>
		</PortfolioFormShell>
	);
};
